import React, { useContext, useEffect, useState } from "react";

import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import LocaleContext from "../LocaleContext";
import AuthContext from "../components/shared/AuthContext";
import OrgContext from "../organisation/OrgContext";

import { formatNumber } from "../helpers/formater";
import jwtInterceoptor from "../components/shared/jwtInterceptor";
import { baseURL } from "../services/api";
import { useSidebar } from "../components/shared/SidebarContext";

import Swal from "sweetalert2";
import { Link } from "react-router-dom";


function Header(props) {
  const { locale } = useContext(LocaleContext);

  const [t, i18n] = useTranslation();

  const { organisation, changeOrg } = useContext(OrgContext);

  const [organisations, setOrganisations] = useState([]);

  const { user, logout } = useContext(AuthContext);
  const [notifications, setNotifications] = useState([]);
  const { toggleSidebar } = useSidebar();


  useEffect(() => {
    const fetchOrganisations = async () => {
      const response = await jwtInterceoptor.get("/data/organisations");

      if (response.status === 200) {
        setOrganisations(response.data.data);
      }
    };

    fetchOrganisations();
  }, []);
  
  useEffect(()=>{
    const fetchNotifications = async () => {
        // Fetch notifications
        const response = await jwtInterceoptor.get(
          "/data/notifications/" + organisation.id
        );
        if (response.status === 200) {
          setNotifications(response.data.data); // Save notifications in state
        }
      };

    if(organisation)
      fetchNotifications();
  },[organisation])

  const changeLanguage = async (l) => {
    console.log(l);
    if (locale !== l) {
      i18n.changeLanguage(l);
      try {
        await localStorage.setItem("lang", l);
      } catch (error) {
        console.error(error);
      }
    } else {
      console.log("locale is undefined");
    }
  };

  const _logout = (event) => {
    event.preventDefault();
    useEffect(() => {
      const fetchOrganisations = async () => {
        const response = await jwtInterceoptor.get("/data/organisations");
        if (response.status === 200) {
          setOrganisations(response.data.data);
        }
      };

      const fetchNotifications = async () => {
        // Fetch notifications
        const response = await jwtInterceoptor.get("/data/notifications");
        if (response.status === 200) {
          setNotifications(response.data.data); // Save notifications in state
        }
      };

      fetchOrganisations();
      fetchNotifications(); // Fetch notifications on mount
    }, []);
    logout();
  };



  const handleNotificationClick = (notification) => {
    // Handle notification click (mark as read, navigate, etc.)
    console.log("Notification clicked:", notification);
  };
  return (
    <>
      <div className="app-header header staticy">
        <div className="container-fluid main-container">
          <div className="d-flex">
            
            <a className="logo-horizontal " href="index.html">
              {/* <img src="../assets/images/brand/logo.png" className="header-brand-img desktop-logo" alt="logo" />
                          <img src="../assets/images/brand/logo-3.png" className="header-brand-img light-logo1"
                              alt="logo" /> */}
            </a>
            <div className="d-flex order-lg-2 ms-auto header-right-icons">
              <button
                className="navbar-toggler navresponsive-toggler d-lg-none ms-auto"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent-4"
                aria-controls="navbarSupportedContent-4"
                aria-expanded="false"
                 onClick={toggleSidebar}
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon fe fe-more-vertical"></span>
              </button>
              <div className="navbar navbar-collapse responsive-navbar p-0">
                <div
                  className="collapse navbar-collapse"
                  id="navbarSupportedContent-4"
                >
                  <div className="d-flex order-lg-2">
                    <div className="dropdown d-lg-none d-flex">
                      <div className="dropdown-menu header-search dropdown-menu-start">
                        <div className="input-group w-100 p-2">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Search...."
                          />
                          <div className="input-group-text btn btn-primary">
                            <i className="fa fa-search" aria-hidden="true"></i>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/*<div className="d-flex country">*/}
                    {/*  <a*/}
                    {/*    className="nav-link icon text-center"*/}
                    {/*    data-bs-target="#country-selector"*/}
                    {/*    data-bs-toggle="modal"*/}
                    {/*  >*/}
                    {/*    <i className="fe fe-globe"></i>*/}
                    {/*    <span className="fs-16 ms-2 d-none d-xl-block">*/}
                    {/*      {i18n.language == "fr" ? "Français" : "English"}*/}
                    {/*    </span>*/}
                    {/*  </a>*/}
                    {/*</div>*/}
                    {/* notification modal  */}
                    {/* <div className="d-flex notification">
    <a className="nav-link icon text-center" data-bs-target="#notification-modal" data-bs-toggle="modal">
        <i className="fe fe-bell"></i><span                                               className="fs-16 ms-2 d-none d-xl-block">Notification</span>
        {notifications.length > 0 && <span className="badge badge-pill badge-danger">{notifications.length}</span>}
    </a>
</div> */}

                    <div className="dropdown  d-flex message">
                      <a
                        className="nav-link text-center"
                        data-bs-toggle="dropdown"
                      >
                        {organisation ? organisation.name : ""}
                        <i
                          className="fa fa-angle-down iconOrganisationSwitch"
                          data-bs-toggle="tooltip"
                          title=""
                          data-bs-original-title="fa fa-angle-down"
                          aria-label="fa fa-angle-down"
                        ></i>
                      </a>
                      <div className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <div className="drop-heading border-bottom">
                          <div className="d-flex">
                            <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">
                              {t("Votre Organisations")}
                            </h6>
                          </div>
                        </div>
                        <div className="message-menu">
                          {organisations.map((or) => (
                            <a
                              onClick={() => {
                                if (or.id != organisation?.id) {
                                  try {
                                    changeOrg(or);
                                    window.location.reload();
                                  } catch (error) {
                                    Swal.fire({
                                      icon: "warning",
                                      title: "",
                                      text: t(
                                        "Something went wrong!, try again"
                                      ),
                                    });
                                  }
                                }
                              }}
                              key={or.id}
                              className={
                                or.id == organisation?.id
                                  ? "dropdown-item d-flex active"
                                  : "dropdown-item d-flex"
                              }
                              style={{ display: "block" }}
                            >
                              <img
                                className="avatar avatar-md brround me-3 align-self-center cover-image"
                                src={`${baseURL.replace(
                                  "/api",
                                  ""
                                )}/upload/logo/${or.logo}`}
                              />
                              <div className="wd-90p">
                                <div className="d-flex">
                                  <h5 className="mb-1">{or.name}</h5>
                                  <small className="text-muted ms-auto text-end">
                                    {or.id == organisation?.id
                                      ? organisation?.currency?.code
                                      : or.currency.code}
                                  </small>
                                </div>
                                <span>{or.activity.name}</span>
                                <br />
                                <span>
                                  {or.country.name} - {or.city}
                                </span>
                              </div>
                            </a>
                          ))}
                        </div>
                        <div className="dropdown-divider m-0"></div>
                        <Link
                          to="/organisations/list"
                          className="dropdown-item text-center p-3 text-muted"
                        >
                          {t("Voir toutes les organisations")}
                        </Link>
                      </div>
                    </div>
                    <div className="dropdown d-flex message">
                      <a
                        className="nav-link text-center"
                        data-bs-toggle="dropdown"
                        aria-expanded="false" // Ensure this attribute is present
                      >
                        <i className="fe fe-bell"></i>
                        {notifications.length > 0 && (
                          <span
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              width: "20px",
                              height: "20px",
                              borderRadius: 10,
                            }}
                          >
                            {notifications.length}
                          </span>
                        )}
                      </a>
                      <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                        <li className="drop-heading border-bottom">
                          <h6 className="mt-1 mb-0 fs-16 fw-semibold text-dark">
                            Notifications
                          </h6>
                        </li>
                        <div className="message-menu">
                          {notifications.length > 0 ? (
                            notifications.map((notification) => (
                              <li
                                key={notification.id}
                                style={{
                                  borderBottom: "3px dotted",
                                  borderBottomColor:
                                    notification.text_color === "#378006"
                                      ? "#378006"
                                      : "#d20404",
                                }}
                                className="dropdown-item d-flex"
                                onClick={() =>
                                  handleNotificationClick(notification)
                                }
                              >
                                <span className="notification-icon">
                                  <i
                                    className="fe fe-bell"
                                    style={{
                                      color:
                                        notification.text_color === "#378006"
                                          ? "#378006"
                                          : "#d20404",
                                    marginRight:5
                                    }}
                                  ></i>
                                </span>
                                <div className="wd-90p">
                                  {notification.text_color === "#378006" ? (
                                    <h5 className="mb-1">
                                      Attention, la {notification.title} est
                                      proche de la date d'échéance
                                    </h5>
                                  ) : (
                                    <h5 className="mb-1">
                                      Attention, aujourd'hui est la date
                                      d'échéance du {notification.title}
                                    </h5>
                                  )}
                                  <small className="text-muted">
                                    Date d'échéance : {notification.due_date}
                                  </small>
                                </div>
                              </li>
                            ))
                          ) : (
                            <li className="dropdown-item text-center">
                              <span>Aucune notification</span>
                            </li>
                          )}
                        </div>
                        <div className="dropdown-divider m-0"></div>
                        <li>
                          <Link
                            to="/calendar"
                            className="dropdown-item text-center p-3 text-muted"
                          >
                            Voir la Calendrier
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal fade" id="country-selector">
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content country-select-modal">
            <div className="modal-header">
              <h6 className="modal-title">{t("language")}</h6>
              <button
                aria-label="Close"
                className="btn-close"
                data-bs-dismiss="modal"
                type="button"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <ul className="row p-3">
                <li className="col-lg-6 mb-2">
                  <button
                    onClick={() => changeLanguage("en")}
                    className={
                      i18n.language === "en"
                        ? "btn btn-country btn-lg btn-block active"
                        : "btn btn-country btn-lg btn-block"
                    }
                  >
                    <span className="country-selector">
                      <img
                        alt=""
                        src="../assets/images/flags/us_flag.jpg"
                        className="me-3 language"
                      />
                    </span>
                    {t("English")}
                  </button>
                </li>
                <li className="col-lg-6 mb-2">
                  <button
                    onClick={() => changeLanguage("fr")}
                    className={
                      i18n.language === "fr"
                        ? "btn btn-country btn-lg btn-block active"
                        : "btn btn-country btn-lg btn-block"
                    }
                  >
                    <span className="country-selector">
                      <img
                        alt=""
                        src="../assets/images/flags/french_flag.jpg"
                        className="me-3 language"
                      />
                    </span>
                    {t("French")}
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Modal for notifications */}
      {/* <div className="modal fade" id="notification-modal">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content notification-modal-content">
                        <div className="modal-header">
                            <h6 className="modal-title">Notifications</h6>
                            <button aria-label="Close" className="btn-close" data-bs-dismiss="modal" type="button">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <ul className="row p-3">
                                {notifications.length > 0 ? (
                                    notifications.map((notification, index) => (
                                        <li key={index} className="col-lg-12 mb-2">
                                            <button
                                                onClick={() => handleNotificationClick(notification)}
                                                className="btn btn-notification btn-lg btn-block">
                                                <span className="notification-icon">
                                                    <i className="fe fe-bell"></i>
                                                </span>
                                                <span>{notification.title}</span>
                                            </button>
                                        </li>
                                    ))
                                ) : (
                                    <li className="col-lg-12 text-center">
                                        <span>Aucune notification</span>
                                    </li>
                                )}
                            </ul>
                        </div>
                    </div>
                </div>
            </div> */}

      {/* Button to trigger the modal */}
      {/* <button className="btn btn-primary" data-bs-toggle="modal" data-bs-target="#notification-modal">
                Voir les notifications
            </button> */}
    </>
  );
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps)(Header);
